var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation-info_Field"},[_c('span',{staticClass:"confirmation-info_Field-left"},[_vm._v(_vm._s(_vm.label)+":")]),_c('span',{staticClass:"confirmation-info_Field-right"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }